import * as Sentry from "@sentry/react";
import { useToastsContext } from "@lending/hooks/useToasts";
import { useApi } from "@lending/lib/api";

const noop = () => Promise.resolve();

interface Props {
  onSuccess?: () => Promise<void> | void;
}

function useDeleteApplicationApplicantDetailsQuery(props: Props = {}) {
  const { onSuccess = noop } = props;
  const $api = useApi();
  const { showGenericErrorToast, clearToasts } = useToastsContext();

  return $api.useMutation("delete", "/v2/lending/application_applicant_details/{uuid}/", {
    onSuccess: async () => {
      clearToasts();
      await onSuccess();
    },
    onError: (error) => {
      showGenericErrorToast();
      Sentry.captureException(error);
    },
  });
}

export { useDeleteApplicationApplicantDetailsQuery };
